import { FC, useEffect, useState } from "react";
import { useNavigate } from "../../hooks/navigate";
import styles from "./Menu.module.scss";
import { useLocation } from "react-router-dom";
import { useSelector } from "../../hooks";
import { Highlightable } from "../Highlight/Highlightable";
import { ActionPromptType } from "../../hooks/prompts";
import { AppContext } from "./app-context";

export { AppContext } from "./app-context";

export interface IMenuButton {
    context: AppContext;
    caption: string;
    icon: string;
    promptType?: ActionPromptType;
}

export const MenuButton: FC<IMenuButton> = ({ context, caption, icon, promptType }) => {
    const [isActive, setIsActive] = useState(false);
    const navigate = useNavigate();
    const currentContext = useSelector(store => store.appData.context);
    const location = useLocation();

    useEffect(() => {
        const path = location.pathname.split('/')?.[1];
        setIsActive(context === path);
    }, [location, context])

    const handler = () => {
        navigate(context);
    }

    const getButton = () => (
        <button
            className={`${styles.item} ${isActive || currentContext === context ? styles.active : ""}`}
            onClick={ handler }
        >
            <img src={icon} alt={caption} className={styles.icon} />
            { caption }
        </button>
    );

    const getPromptType = () => !isActive && promptType ? promptType : ActionPromptType.NONE;
    
    return (
        <>
            { <Highlightable promptType={ getPromptType() } >
                    { getButton() }
              </Highlightable>
            }   
        </>     
    );
}
